var cloneDeep = require('lodash/cloneDeep');
var constants = require('../constants');
var utils = require('../../survey/utils');
var responseUtils = require('../utils');
var action = require('./clear-current-response');
var nextAction = require('../../survey/actions/fetch-next-question');
var surveyStateHistoryActions = require('../../surveyStateHistory/actions/surveyStateHistory');
var profileActions = require('../../profile/actions/profile');
var clinicalTrialsMetaActions = require('../../meta/actions/clinical-trials');

var SubmitResponse = (function() {

    var _submitResponse = function() {
        return function(dispatch, getState) {
            var state = getState();
            var history = state.surveys;
            var surveys = state.entities.surveys;
            var currentResponse = state.responses.currentResponse;
            var surveyId = utils.getSurveyId(history, history.currentSurveyIndex);
            var sequenceId = utils.getSequenceId(surveys, surveyId, history.currentSequenceIndex);
            var currentField = utils.getCurrentField(state.entities.fields, sequenceId);

            if (responseUtils.isValidAnswer(getState().responses.currentResponse, currentField, dispatch)) {
                if(surveyId === 'clinical_trials_opt_in_survey') {
                    currentResponse[0].tag === 'yes' && dispatch(profileActions.interestedInClinicalTrials(null, state.auth.token));
                    dispatch(clinicalTrialsMetaActions.recordClinicalTrialsQuestion(currentResponse[0].label || currentResponse[0].tag));
                } else {
                    dispatch(surveyStateHistoryActions.cacheSurveyState());

                    var currentResponseClone = cloneDeep(currentResponse);
                    currentResponseClone.forEach(function(x){
                        delete x.unique;
                    });
                    var data = [surveyId, sequenceId, currentResponseClone];

                    dispatch(_concatCurrentResponse(data));
                }

                dispatch(action.clearCurrentResponse());
                dispatch(nextAction.fetchNextQuestion(sequenceId, currentResponse));
            } else {
                // console.log('DENIED!')
            }
        };
    }

    var _concatCurrentResponse = function(data) {
        return {
            type: constants.SUBMIT_RESPONSE,
            data: data
        };
    }

    return {
        submitResponse: _submitResponse
    }
})();

module.exports = SubmitResponse;



// WEBPACK FOOTER //
// ./src/common/modules/responses/actions/submit-response.js